import { noddiAsync, URLKeys } from 'noddi-async';

/** Fetch manager data only for cars already visible in another paginated list. */
export const useNotificationOverviewCars = (userGroupId: number, carIds: number[], enabled = true) =>
  noddiAsync.useGet({
    type: URLKeys.getPaginatedNotificationOverviewCars,
    input: { userGroupId, carIds },
    queryConfig: { enabled: enabled && carIds.length > 0 }
  });
